import {Directive} from '@angular/core';

@Directive({
    selector: '[appContentSuffix]',
    standalone: true
})
export class ContentSuffixDirective {
}
